/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.megadodo.MegadodoPhase
*/
export var MegadodoPhase;
(function (MegadodoPhase) {
    MegadodoPhase["START"] = "START";
    MegadodoPhase["END"] = "END";
    MegadodoPhase["SINGLE"] = "SINGLE";
})(MegadodoPhase || (MegadodoPhase = {}));
//# sourceMappingURL=MegadodoPhase.js.map